/* tslint:disable */
/* eslint-disable */
/**
 * Care& API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.9.4
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { TenantAdministeredDrug } from './TenantAdministeredDrug';
import {
    TenantAdministeredDrugFromJSON,
    TenantAdministeredDrugFromJSONTyped,
    TenantAdministeredDrugToJSON,
} from './TenantAdministeredDrug';
import type { TenantFeeScheduleHistoryEntry } from './TenantFeeScheduleHistoryEntry';
import {
    TenantFeeScheduleHistoryEntryFromJSON,
    TenantFeeScheduleHistoryEntryFromJSONTyped,
    TenantFeeScheduleHistoryEntryToJSON,
} from './TenantFeeScheduleHistoryEntry';
import type { TenantImmunizationFee } from './TenantImmunizationFee';
import {
    TenantImmunizationFeeFromJSON,
    TenantImmunizationFeeFromJSONTyped,
    TenantImmunizationFeeToJSON,
} from './TenantImmunizationFee';

/**
 * 
 * @export
 * @interface TenantFeeSchedule
 */
export interface TenantFeeSchedule {
    /**
     * Fixed literal 'main' — one record per tenant.
     * @type {string}
     * @memberof TenantFeeSchedule
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof TenantFeeSchedule
     */
    tenant_id?: string;
    /**
     * Optimistic-concurrency counter, server-incremented on every save. Updates must echo the version they loaded; a mismatch returns 409 so a stale tab cannot silently drop another admin's price edits.
     * @type {number}
     * @memberof TenantFeeSchedule
     */
    version?: number;
    /**
     * Fee options attached to global immunization catalog items. Tenants cannot define immunizations — only price them.
     * @type {Array<TenantImmunizationFee>}
     * @memberof TenantFeeSchedule
     */
    immunization_fees?: Array<TenantImmunizationFee>;
    /**
     * The tenant's own administered-drug entries. No global list and no defaults — new tenants start empty.
     * @type {Array<TenantAdministeredDrug>}
     * @memberof TenantFeeSchedule
     */
    administered_drugs?: Array<TenantAdministeredDrug>;
    /**
     * 
     * @type {Array<TenantFeeScheduleHistoryEntry>}
     * @memberof TenantFeeSchedule
     */
    history?: Array<TenantFeeScheduleHistoryEntry>;
}

/**
 * Check if a given object implements the TenantFeeSchedule interface.
 */
export function instanceOfTenantFeeSchedule(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function TenantFeeScheduleFromJSON(json: any): TenantFeeSchedule {
    return TenantFeeScheduleFromJSONTyped(json, false);
}

export function TenantFeeScheduleFromJSONTyped(json: any, ignoreDiscriminator: boolean): TenantFeeSchedule {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'tenant_id': !exists(json, 'tenant_id') ? undefined : json['tenant_id'],
        'version': !exists(json, 'version') ? undefined : json['version'],
        'immunization_fees': !exists(json, 'immunization_fees') ? undefined : ((json['immunization_fees'] as Array<any>).map(TenantImmunizationFeeFromJSON)),
        'administered_drugs': !exists(json, 'administered_drugs') ? undefined : ((json['administered_drugs'] as Array<any>).map(TenantAdministeredDrugFromJSON)),
        'history': !exists(json, 'history') ? undefined : ((json['history'] as Array<any>).map(TenantFeeScheduleHistoryEntryFromJSON)),
    };
}

export function TenantFeeScheduleToJSON(value?: TenantFeeSchedule | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'tenant_id': value.tenant_id,
        'version': value.version,
        'immunization_fees': value.immunization_fees === undefined ? undefined : ((value.immunization_fees as Array<any>).map(TenantImmunizationFeeToJSON)),
        'administered_drugs': value.administered_drugs === undefined ? undefined : ((value.administered_drugs as Array<any>).map(TenantAdministeredDrugToJSON)),
        'history': value.history === undefined ? undefined : ((value.history as Array<any>).map(TenantFeeScheduleHistoryEntryToJSON)),
    };
}

